import { render, staticRenderFns } from "./ArticleNote.vue?vue&type=template&id=2365e03c&scoped=true&"
import script from "./ArticleNote.vue?vue&type=script&lang=js&"
export * from "./ArticleNote.vue?vue&type=script&lang=js&"
import style0 from "./ArticleNote.vue?vue&type=style&index=0&id=2365e03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365e03c",
  null
  
)

export default component.exports